import * as Yup from "yup";

export const evaluationSchema = Yup.object().shape({
    idMember: Yup.string()
        .required("Selecione o aluno que está sendo avaliado"),
    idEmployee: Yup.string()
        .required("Identifique o avaliador responsável"),
    employeeName: Yup.string().nullable(),
        
    idActivity: Yup.string()
        .required("Selecione qual modalidade está sendo avaliada"),
    activityName: Yup.string().nullable(),
    
    idLevel: Yup.string()
        .required("Selecione para qual nível/faixa ele está prestando o exame"),
    levelName: Yup.string().nullable(),

    date: Yup.date()
        .required("Data da avaliação é obrigatória"),
        
    observations: Yup.string().nullable(),
    
    // Lista minuciosa das notas do aluno no momento da prova (Salvamos o valor e o booleano de corte)
    grades: Yup.array().of(
        Yup.object().shape({
            idObjective: Yup.string().required(),
            idTopic: Yup.string().required(),
            score: Yup.number().min(0).max(5).required(), // Ex: Estrelas de 0 a 5
            isFundamental: Yup.boolean().default(false) // Pra travar aprovação se ele zerar um critério fundamental
        })
    ).default([]),

    totalScore: Yup.number().default(0), 
    averageScore: Yup.number().default(0),
    
    idEvent: Yup.string().nullable(),
    eventName: Yup.string().nullable(),
    
    status: Yup.string()
        .oneOf(["IN_PROGRESS", "PASSED", "FAILED"])
        .default("IN_PROGRESS") 
});
